<template>
  <div>
    <v-card v-for="n in 3" :key="n" flat class="mt-5 rounded-lg">
      <v-row class="ps-0 ma-0">
        <v-col cols="5" sm="2" lg="1" class="text-start">
          <v-skeleton-loader
            height="80"
            max-height="100"
            type="image"
            class="rounded-lg"
          />
        </v-col>

        <v-col class="ps-0 align-self-center">
          <v-skeleton-loader height="12" type="text" class="mb-2" />

          <v-skeleton-loader height="12" type="text" />
        </v-col>

        <template v-if="$vuetify.breakpoint.smAndUp">
          <v-col cols="1" class="align-self-center justify-center">
            <v-skeleton-loader height="12" type="text" />
          </v-col>

          <v-col cols="2" class="align-self-center justify-center">
            <v-skeleton-loader type="avatar" />
          </v-col>

          <v-col cols="2" class="align-self-center justify-center">
            <v-skeleton-loader height="12" type="text" />
          </v-col>

          <v-col cols="2" class="align-self-center justify-center">
            <v-skeleton-loader height="12" type="text" />
          </v-col>
        </template>
      </v-row>
    </v-card>
  </div>
</template>

<script>
export default {};
</script>
